import { render, staticRenderFns } from "./RichTextWidgetPanel.vue?vue&type=template&id=36ae88c8&scoped=true"
import script from "./RichTextWidgetPanel.vue?vue&type=script&lang=js"
export * from "./RichTextWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./RichTextWidgetPanel.vue?vue&type=style&index=0&id=36ae88c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae88c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ae88c8')) {
      api.createRecord('36ae88c8', component.options)
    } else {
      api.reload('36ae88c8', component.options)
    }
    module.hot.accept("./RichTextWidgetPanel.vue?vue&type=template&id=36ae88c8&scoped=true", function () {
      api.rerender('36ae88c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/RichTextWidgetPanel.vue"
export default component.exports